import * as React from 'react';
import { basePageWrap } from '../BasePage';
import s from './CaseListPage.module.scss';

import CardImageBranding from '../../components/CardImageBranding';

import CaseFilter, {
    CaseCategoryItem
} from '../../components/CaseFilter/CaseFilter';

import Billboard, {
    BillboardProps,
} from '../../components/Billboard/Billboard';

import { Image } from "../../types/index";
import { MediaQuery } from "../../components/Image/Image";


interface CaseListPageProps {
    title: string;
    billboard: BillboardProps;
    caseCategories: Array<CaseCategoryItem>
    content: any[];
    enableFiltering: boolean;
}

class CaseListPage extends React.PureComponent<CaseListPageProps> {
    state = {
        activeCategories: []
    };

    toggleCaseCategory = (slug: string | null) => {
        const activeCategories: Array<string> = this.state.activeCategories;
        let newActiveCategories: Array<string> = [];

        if (activeCategories.indexOf(slug) > -1) {
            newActiveCategories = activeCategories
                .filter(c => c !== slug);
        } else {
            newActiveCategories = slug
                ? [...activeCategories, slug]
                : [];
        }

        this.setState({ activeCategories: newActiveCategories });
    }

    render() {
        const {
            billboard, caseCategories, content = [], title, enableFiltering
        } = { ...this.props };
        const activeCategories = this.state.activeCategories;

        const isCaseInCurrentFilter = (page) => {
            if (activeCategories.length === 0) {
                return true;
            }

            return page.categories.reduce((b, c) => {
                return b === true
                    ? true
                    : activeCategories.indexOf(c.slug) > -1
            }, false)
        };

        let pages = [];
        if (content[0] && content[0].value) {
            pages = content[0].value.items.filter(isCaseInCurrentFilter);
        }

        const noFilteredCases = !isCaseInCurrentFilter(billboard) && pages.length === 0;

        return (
            <div className={s.Root}>
                <div className={s.HeadlineWrap}>
                    <h1
                        className={s.Headline}
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                </div>
                {enableFiltering && (
                    <div className={s.CaseFilter}>
                        <CaseFilter
                            categories={caseCategories}
                            activeCategories={this.state.activeCategories}
                            onFilterToggleButtonClick={this.toggleCaseCategory}
                        />
                    </div>
                )}

                {isCaseInCurrentFilter(billboard) && (
                    <div className={s.Billboard}>
                        <Billboard {...billboard} />
                    </div>
                )}

                {noFilteredCases && (
                    <div className={s.FilterEmpty}>
                        Inga case hittades för din filtrering - kika gärna in
                        igen snart!
                    </div>
                )}

                {pages.length !== 0 && <CaseGrid pages={pages} />}
            </div>
        );
    }
}

type CaseGridProps = {
    pages: Array<any>;
};

const CaseGrid: React.FC<CaseGridProps> = ({ pages }) => {
    let widePosition: number = 6;
    let everyOtherWidePosition: boolean = true;

    const checkIfWidePosition = (index: number): boolean => {
        if (index % widePosition !== 0) {
            return false;
        }

        if (index === 0) {
            return true;
        }

        if (everyOtherWidePosition) {
            widePosition += 4;
            everyOtherWidePosition = false;
            return true;
        }

        widePosition += 6;
        everyOtherWidePosition = true;
        return true;
    };

    const getMediaQueries = ({
        wide = false,
        image,
    }: {
        wide: boolean;
        image: Image;
    }): MediaQuery[] => {
        if (wide) {
            return [{ minWidth: 480, src: image.renditions?.large.src }];
        }

        return [
            { minWidth: 960, src: image.renditions?.small.src },
            { minWidth: 480, src: image.renditions?.large.src },
        ];
    };

    return (
        <div className={s.CaseList}>
            {pages.filter(page => !!page).map((page, index) => {
                let mediaQueries = getMediaQueries({
                    wide: checkIfWidePosition(index),
                    image: page.image,
                });

                mediaQueries = mediaQueries.filter((x) => x.src);

                return (
                    <a href={page.url} className={s.CaseItem} key={index}>
                        <CardImageBranding
                            {...page}
                            title={page.clientName}
                            tag={page.title}
                            mediaQueries={mediaQueries}
                        />
                    </a>
                );
            })}
        </div>
    );
};

export default basePageWrap(CaseListPage);
